<template>
  <el-row>
    <el-col :span="12">
      <el-form-item label="选项" prop="dictType">
        <el-select v-model="value.dictType" size="small" @change="changeCode" filterable clearable>
          <el-option-group v-for="grp in generalDict" :key="grp.code" :label="grp.text">
            <el-option v-for="item in grp.options" :key="item.code" :label="item.text" :value="item.code" />
          </el-option-group>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col v-if="value.dictType" :span="12">
      <el-form-item label="默认选中项编码" prop="Code">
        <el-select v-model="value.Code" size="small" filterable>
          <el-option v-for="item in defaultDictList" :key="item.code" :label="item.text" :value="item.code" />
        </el-select>
      </el-form-item>
    </el-col>
    <el-form-item label="列表选中项显示" label-width="30em" prop="ShowValue">
      <el-radio-group v-model="value.ShowValue">
        <el-radio :label="false">值</el-radio>
        <el-radio :label="true">编码</el-radio>
      </el-radio-group>
    </el-form-item>
  </el-row>
</template>

<script>
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      value: Object,
    },
    data() {
      return {
        generalDict: [
          { code: "dict", text: "字典类型", options: [] },
          {
            code: "enum",
            text: "枚举类型",
            options: [
              { code: "enum.MrScope", text: "病历领域" },
              // { code: "enum.MrAuditState", text: "病历审批状态" },
              // { code: "enum.MrElementType", text: "病历元素类型" },
              { code: "enum.MrApiResultType", text: "病历接口结果类型" },
              { code: "enum.TargetType", text: "挂号目标类型" },
              { code: "enum.RpClass", text: "处方类型" },
              { code: "enum.RpPaymentState", text: "处方支付状态" },
              { code: "enum.TreatmentState", text: "远程会诊状态" },
              { code: "enum.DiagnosisType", text: "诊断类型" },
              { code: "enum.ExamineResult", text: "发药确认状态" },
              { code: "enum.GoodsType", text: "药品类型" },
              { code: "enum.DrugStorehouseType", text: "药品库房类型" },
              { code: "enum.AuditState", text: "审批状态" },
              { code: "enum.OffsetState", text: "冲单状态" },
              // { code: "enum.DrugGenerateState", text: "" },
              // { code: "enum.DrugStockinEvent", text: "药品" },
              // { code: "enum.DrugStocktakingState", text: "" },
              { code: "enum.DistributeState", text: "发药状态" },
              { code: "enum.OpType", text: "就诊类型" },
              // { code: "enum.DockingSolution", text: "" },
              { code: "enum.RegState", text: "就诊号状态" },
              { code: "enum.PeriodType", text: "午别" },
              { code: "enum.OpRotaType", text: "就诊号排班类型" },
              { code: "enum.PayType", text: "支付方式" },
              // { code: "enum.InvoiceType", text: "发票记录类型" },
              { code: "enum.PaymentState", text: "支付状态" },
              // { code: "enum.PrescriptionType", text: "" },
              { code: "enum.CriticalLevel", text: "危重等级" },
              { code: "enum.DeptType", text: "科室类型" },
              { code: "enum.TreatType", text: "处置类型" },
            ],
          },
        ],
        defaultDictList: [],
      };
    },
    computed: {
      ...mapGetters(["Enum", "dictEnum"]),
    },
    created() {
      this.getGeneralDict();
      if (this.value.dictType) this.getDefaultDictList(this.value.dictType);
    },
    methods: {
      getGeneralDict() {
        this.$api.Dict.query({ type: "DictType", global: true }).then((res) => {
          this.generalDict[0].options = res.items;
        });
      },
      getDefaultDictList(type) {
        if (type.indexOf("enum.")==0) {
          this.defaultDictList = this.dictEnum[type.substring(5)];
        } else {
          this.$api.Dict.query({ type }).then((res) => {
          this.defaultDictList = res.items;
        });
        }
        
      },
      changeCode(type) {
        this.value.Code = null;
        this.getDefaultDictList(type, this.defaultDictList);
      },
    },
  };
</script>
